<template>
  <v-container>
  <!-- <pre v-if="recintosProvincia">
  {{ $route.params.id }} a {{ recintosProvincia.length }}
  
    {{ listadoRecintos[0]  }} dd {{ Object.keys(recintosJanto) }}

  </pre> -->
 <!-- {{ Object.keys($store.state.recintosJanto) }} -->
    <v-layout>
      <v-flex v-if="recintosProvincia && recintosProvincia.length > 0" xs12>
        <v-card class="elevation-3">
          <v-container
            grid-list-md
            fluid
            class="pa-3"
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                v-for="(recinto, n) in recintosProvincia"
                :key="n"
                xs12
                sm6
                md4
                d-flex
              >

              <pre v-if="!recinto.fields">
                {{ recinto}}
              </pre>
         
                <v-card
                  v-if="recinto.fields"
                  flat
                  tile
                  class="d-flex"
                  :to="`/${$i18n.locale}/ver-recinto/${recinto.fields.idRecinto}`"
                  color="white"
                >
                  <v-img
                    v-if="recinto.fields.imageUrl"
                    :src="recinto.fields.imageUrl"
                    aspect-ratio="1"
                    color="grey lighten-3"
                  >
                    <template slot="placeholder">
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular
                          indeterminate
                          :color="colorDestacado"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                    <v-layout
                      fill-height
                      row
                      align-end
                      justify-content-center
                      wrap
                    >

                      <v-card-text class="sombra white--text font-weight-bold subheading text-xs-center">{{recinto.fields.Nombre}} </v-card-text>

                    </v-layout>
                  </v-img>
                  <v-img
                    v-else
                    :src="urlRecinto(recinto.fields)"
                    aspect-ratio="1"
                    contain
                    color="grey lighten-3"
                    class="contener"
                  >
                    <template slot="placeholder">
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular
                          indeterminate
                          :color="colorDestacado"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                    <v-layout
                      fill-height
                      row
                      align-end
                      justify-content-center
                      wrap
                    >

                      <v-card-text class="font-weight-bold subheading text-xs-center">{{recinto.fields.Nombre}} </v-card-text>
                      

                    </v-layout>
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template> 

<style>
a:focus,
a:hover {
  text-decoration: none;
}
.sombra {
  text-shadow: 2px 2px #333;
}
.contener .v-image__image.v-image__image--contain {
  background-size: 65%;
}
</style>


<script>
import { globales } from "../comunes";
import { STATIC_RECINTOS } from "@/config/setup";
export default {
  mixins: [globales],
  watch: {
    $route(to, from) {
      // this.getRecintos();
    },
  },
  props: ["listadoRecintos"],
  mounted() {
    // this.$store.dispatch('getRecintos')
    // this.getRecintos();
  },
  computed: {
    recintosProvincia() {
  if (!this.listadoRecintos || this.listadoRecintos.length === 0) {
    return [];
  }

  const provinciaRuta = this.$route.params.id.toLowerCase();

  return this.listadoRecintos.filter(e => {
    if (!e.fields || !e.fields.Provincia || !e.fields.Provincia.Nombre) {
      return false;
    }

    const provincia = e.fields.Provincia.Nombre.toLowerCase();

    if (provinciaRuta === "cordoba") {
      return provincia === "córdoba" || provincia === "cordoba";
    }

    return provincia === provinciaRuta;
  });
},
    recintosWeb() {
      const allEvents = this.listadoRecintos;

      const filtro = this.$route.params.id;

      const recintos = allEvents.filter(
        e => e.fields.Provincia.Nombre.toLowerCase() == filtro
      );
      if (recintos) {
        // return recintos.filter(e=>!e.fields.imageUrl)
        const misRecintos = [];

        const recintosJanto = this.$store.state.recintosJanto;

        Object.keys(recintosJanto).forEach(actual =>
          misRecintos.push(recintosJanto[actual])
        );

        // recintos.forEach(recinto => {
        //   const idRecinto = recinto.fields.idRecinto;
        //   if (recintosJanto.hasOwnProperty(idRecinto)) {
        //     misRecintos.push(recinto);
        //   }
        // });
        // console.log('recintosWEb', misRecintos)
        return misRecintos.sort(function(a, b) {
          // console.log('ordenar',a.recinto.Nombre,b.recinto.Nombre)
          var nameA = a.recinto.Nombre.toUpperCase(); // ignore upper and lowercase
          var nameB = b.recinto.Nombre.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });
      } else {
        return [];
      }
    },
    recintosJanto() {
      const recintosJanto = this.$store.state.recintosJanto;
      return recintosJanto;
    },
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Imagen",
          align: "left",
          sortable: false,
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "recinto.Nombre",
        },
        { text: "Dirección", value: "recinto.Direccion" },
        { text: "Poblacion", value: "recinto.Poblacion.Nombre" },
        { text: "Provincia", value: "recinto.Provincia.Nombre" },
        { text: "Instalacion", value: "recinto.Instalacion" },
        // { text: "Eventos", sortable: true, value: "eventos.length" },
      ],
      listaInstalaciones: {
        Janto_FRESH: "https://tickets.janto.es/static/",
        Janto_KB: "https://ticket.kutxabank.es/static/",
        Janto_DONAT: "https://entradas.janto.es/static/",
        Janto_4TICK: "https://www.4tickets.es/static/",
        Janto_SAB: "https://entradas.instanticket.es/static/",
        Janto_IBER: "https://compraentradas.ibercaja.es/static/",
        Janto_MG: "https://www.mgticket.com/static/",
        Janto_LBANK: "https://entradas.liberbank.es/static/",
        Janto_UNI: "https://www.unientradas.es/static/",
      },
    };
  },
  methods: {
    urlRecinto(recinto) {
      // const imagenRecinto = this.recintosWeb.find(e=>e.fields.idRecinto==recinto.idRecinto)
      // if (imagenRecinto) {
      //   if (imagenRecinto.fields.hasOwnProperty('imageUrl')) {
      //     return imagenRecinto.fields.imageUrl
      //   }
      // }
      console.log("urlRecinto", recinto);
      const Instalacion = recinto.Host;
      const Path = "recintos/";
      const sinImagen = this.sinImagen;
      const conImagen = STATIC_RECINTOS[recinto.Host] + recinto.Imagen;

      const Imagen = recinto.Imagen ? conImagen : sinImagen;

      // console.log("urlRecinto", recinto, Imagen, conImagen);

      if (!Instalacion) {
        console.log("Instalacion SIN", recinto);
      }

      return Imagen;
    },
    getRecintos() {
      const filtro = this.$route.params.id;
      const recintosWeb = this.$store.state.recintosWeb;

      const allEvents = this.eventosWeb.filter(
        e => e.Provincia[0].Nombre.toLowerCase() == filtro
      );
      const misRecintos = {};
      allEvents.forEach(a => {
        let recinto = a.Recinto[0];
        let idRecinto = recinto.idRecinto;
        if (!misRecintos.hasOwnProperty(idRecinto)) {
          let eventos = [];
          recinto.Host = a.Host;
          recinto.Provincia = a.Provincia[0];
          recinto.Poblacion = a.Poblacion[0];
          recinto.Instalacion = a.Instalacion;
          // recinto.idRecinto = idRecinto;
          recinto.CP = a.CP;

          const existe = recintosWeb.find(
            re => re.fields.idRecinto == idRecinto
          );

          const fields = !existe ? recinto : existe.fields;

          misRecintos[idRecinto] = {
            recinto,
            eventos,
            fields,
          };
        }

        misRecintos[idRecinto].eventos.push(a);
      });
      // console.log('NDDADA', misRecintos)
      // this.$store.commit("setRecintosJanto", misRecintos);
    },
  },
};
</script>
